import {
	Paper,
	Typography,
	Box,
	Grid,
	List,
	Slide,
	IconButton,
} from '@mui/material';
import dayjs from 'dayjs';
import { doc } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFirestoreCollectionData, useFirestoreDocData } from 'reactfire';
import StatusIcon from '../Components/StatusIcon/StatusIcon';
import OrdersContext from '../Context/Orders/OrdersContext';
import OrderListItem from '../Components/OrderDetails/OrderListItem';
import DescriptionCard from '../Components/OrderDetails/DescriptionCard';
import DateOfDeliveryCard from '../Components/OrderDetails/DateOfDeliveryCard';
import PlaceOfDelivery from '../Components/OrderDetails/PlaceOfDelivery';
import StatusStepperCard from '../Components/OrderDetails/StatusStepperCard';

// todo Hacer ruta para los pedidos eliminados

export default function OrderDetails() {
	const { ordersRef, itemsRef, setCurrentOrderId } = useContext(OrdersContext);
	const [total, setTotal] = useState(0);
	const { orderId } = useParams();

	const docRef = doc(ordersRef, orderId);
	const { data: specificOrder } = useFirestoreDocData(docRef, {
		idField: 'id',
	});
	const { data: itemsCol } = useFirestoreCollectionData(itemsRef, {
		idField: 'id',
	});

	const calculateTotal = () => {
		const arr = [];
		specificOrder?.items.map((item) => {
			itemsCol?.map((itm) => {
				if (item.value) {
					if (item.name === itm.name) {
						arr.push(item.value * itm.price);
					}
				}
			});
		});
		setTotal(arr.reduce((a, b) => a + b, 0));
	};

	useEffect(() => {
		calculateTotal();
		setCurrentOrderId(orderId);
	}, []);

	const {
		createdAt,
		name,
		status,
		dateOfDelivery,
		placeOfDelivery,
		description,
		id,
		items,
	} = specificOrder;

	return (
		<Slide direction='up' in mountOnEnter unmountOnExit>
			<Paper
				elevation={0}
				sx={{
					backgroundColor: 'primary.main',
					borderRadius: '8px 8px 8px 8px',
					height: '100%',
					marginTop: '8px',
					boxShadow: '0px 0px 6px 3px rgba(0,0,0,0.30)',
					padding: '24px',
				}}
			>
				<Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							flexDirection: 'row',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								alignItems: 'center',
								flexDirection: 'row',
							}}
						>
							<Box
								sx={{
									backgroundColor: '#fff',
									width: '35px',
									height: '35px',
									borderRadius: '50%',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<StatusIcon status={status} />
							</Box>

							<Typography
								variant='h5'
								color='primary.contrastText'
								fontWeight='bold'
								sx={{ marginLeft: '8px' }}
							>
								{name}
							</Typography>
						</Box>
						<Typography color='primary.contrastText' fontWeight='bold'>
							Total
						</Typography>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							flexDirection: 'row',
						}}
					>
						<Typography variant='body2' color='primary.contrastText'>
							Pedido realizado el {dayjs(createdAt).format('DD/MM/YYYY HH:mm')}
						</Typography>

						<Typography
							variant='h5'
							color='primary.contrastText'
							fontWeight='bold'
						>
							${total}
						</Typography>
					</Box>
				</Box>
				<Box sx={{ padding: '0px 0 24px 0' }}>
					<Grid container columnSpacing={3}>
						<Grid item xs={12} xsm={6}>
							<Typography color='primary.contrastText' fontWeight='bold'>
								Articulos
							</Typography>
							<Paper
								elevation={3}
								sx={{
									width: '100%',
									height: '100%',
									backgroundColor: 'white.main',
									borderRadius: '8px',
									padding: '8px',
								}}
							>
								<List
									sx={{
										width: '100%',
										bgcolor: 'background.paper',
										padding: 0,
									}}
								>
									<Typography fontWeight='bold'>Enteros</Typography>
									{items.map((item) => (
										<div key={item.id}>
											{item.category === 'whole' && item.value !== 0 && (
												<OrderListItem item={item} orderId={id} items={items} />
											)}
										</div>
									))}

									<Typography fontWeight='bold'>Rebanadas</Typography>
									{items.map((item) => (
										<div key={item.id}>
											{item.category === 'slice' && item.value !== 0 && (
												<OrderListItem item={item} orderId={id} items={items} />
											)}
										</div>
									))}
								</List>
							</Paper>
						</Grid>
						<Grid
							item
							xs={12}
							xsm={6}
							sx={{ marginTop: { xs: '24px', xsm: '0' } }}
						>
							<Typography color='primary.contrastText' fontWeight='bold'>
								Descripción
							</Typography>

							<DescriptionCard description={description} />
						</Grid>
					</Grid>
				</Box>
				<Box sx={{ padding: '16px 0 16px 0' }}>
					<DateOfDeliveryCard dateOfDelivery={dateOfDelivery} />
				</Box>
				<Box sx={{ padding: '0 0 16px 0' }}>
					<IconButton
						sx={{
							width: '100%',
							height: '100%',
							padding: 0,
						}}
						onClick={() => {
							window.open(
								`https://www.google.com/maps/search/?api=1&query=${placeOfDelivery}`,
								'_blank'
							);
						}}
					>
						<PlaceOfDelivery placeOfDelivery={placeOfDelivery} />
					</IconButton>
				</Box>
				<Box sx={{ width: '100%' }}>
					<StatusStepperCard status={status} id={id} />
				</Box>
			</Paper>
		</Slide>
	);
}
